import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppService } from '../../app.service';
import { ENDPOINTS, ORG_DETAILS } from '../../app.config';

@Component({
  selector: 'app-shipping-delivery',
  templateUrl: './shipping-delivery.component.html'
})
export class ShippingDeliveryComponent implements OnInit {
  data:any = []
  content : any;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };

  showContent:any = []
  constructor(
    private router: Router,
    private appService: AppService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.showContent=[false,false,false]

    window.scrollTo(0,0)
    this.getShippingAndDelivery()
  }

  show1(e:any){
    console.log(e)
    if(this.showContent[e]===true){
      this.showContent[e]=false;
    }else{
      this.showContent[e]=true;
    }
    console.log(this.showContent[e])
  }

  show(e:any){
    console.log(e)
    e = e.target.id
    if(this.showContent[e]===true){
      this.showContent[e]=false;
    }else{
      this.showContent[e]=true;
    }
    console.log(this.showContent[e])
  }

  getShippingAndDelivery() {
    let requestBody = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {

        },
        "pagination": true,
        "paginationDetails": {
          "limit": 0,
          "pageSize": 10
        },
        "sorting": true,
        "sortingDetails": {
          "email": -1
        }
      }
    }
    // MAKE A SERVICE CALL HERE...
    this.appService.postApiCall(requestBody, ENDPOINTS.GET_ALL_SHIPPING_AND_DELIVERY).subscribe(
      resp => {
        if (resp.result.data[0].length !== 0) {
          this.data = resp.result.data[0]
          this.content = this.data.content;
          document.getElementById('terms-content').innerHTML = this.content;
        }
      },
      err => {
        if (err.error.statusCode === 403) {
          // this.alertService.error('Session Time Out! Please login Again', this.options)
          this.router.navigate([`/login-new`], { skipLocationChange: false });
        }
        // else if (err.error.message) {
        //   this.alertService.error(err.error.message, this.options)
        // }
        // else {
        //   this.alertService.error('Something bad happened. Please try again!', this.options);
        // }
      }
    )
  }


}
